// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import Radio from "@mui/material/Radio";
import * as WrappedSectionHeader from "./WrappedSectionHeader.bs.js";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

function WrappedChaseTraits(Props) {
  var allChaseTraits = Props.allChaseTraits;
  var topChaseTraits = Props.topChaseTraits;
  var queueId = Props.queueId;
  var match = React.useState(function () {
        return 1;
      });
  var setSelection = match[1];
  var selection = match[0];
  var played = topChaseTraits.length;
  var top4edChaseTraits = Belt_Array.keep(topChaseTraits, (function (param) {
          return Belt_Array.some(param[1], (function (p) {
                        return p <= 4;
                      }));
        }));
  var top4ed = top4edChaseTraits.length;
  var wonChaseTraits = Belt_Array.keep(topChaseTraits, (function (param) {
          return Belt_Array.some(param[1], (function (p) {
                        if (queueId === 1150) {
                          return p <= 2;
                        } else {
                          return p === 1;
                        }
                      }));
        }));
  var won = wonChaseTraits.length;
  var selectedTraits;
  switch (selection) {
    case 0 :
        selectedTraits = topChaseTraits;
        break;
    case 1 :
        selectedTraits = top4edChaseTraits;
        break;
    case 2 :
        selectedTraits = wonChaseTraits;
        break;
    default:
      selectedTraits = wonChaseTraits;
  }
  return React.createElement("div", {
              className: "pt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "Chase Traits"
                }), React.createElement("div", undefined, "You have reached ", React.createElement("span", {
                      className: "wrapped-num text-primary-11"
                    }, String(played)), " chase traits out of " + String(allChaseTraits.length) + ", top4-ed with ", React.createElement("span", {
                      className: "wrapped-num text-primary-11"
                    }, String(top4ed)), " of them and won with ", React.createElement("span", {
                      className: "wrapped-num text-primary-11"
                    }, String(won)), " of them"), React.createElement("div", {
                  className: "flex"
                }, React.createElement("div", {
                      className: "pt-2 pr-5"
                    }, React.createElement(FormControl, {
                          component: "fieldset",
                          children: React.createElement(RadioGroup, {
                                value: selection,
                                onChange: (function (e) {
                                    var v = Belt_Option.getExn(Belt_Int.fromString(e.target.value));
                                    return Curry._1(setSelection, (function (param) {
                                                  return v;
                                                }));
                                  }),
                                name: "displayType",
                                children: null
                              }, React.createElement(FormControlLabel, {
                                    value: 0,
                                    control: React.createElement(Radio, {
                                          size: "small"
                                        }),
                                    label: "Played"
                                  }), React.createElement(FormControlLabel, {
                                    value: 1,
                                    control: React.createElement(Radio, {
                                          size: "small"
                                        }),
                                    label: "Top 4"
                                  }), React.createElement(FormControlLabel, {
                                    value: 2,
                                    control: React.createElement(Radio, {
                                          size: "small"
                                        }),
                                    label: "Won"
                                  }))
                        })), React.createElement("div", {
                      className: "grid justify-center items-center pt-4 gap-4 grid-cols-[repeat(6,auto)]"
                    }, Belt_Array.map(allChaseTraits, (function (param) {
                            var rank = param[1];
                            var traitId = param[0];
                            return React.createElement("div", {
                                        key: traitId + String(rank),
                                        className: CssJs.style([
                                              CssJs.unsafe("transition", "opacity .5s ease-in-out"),
                                              CssJs.opacity(Belt_Array.some(selectedTraits, (function (param) {
                                                          return traitId === param[0];
                                                        })) ? 1 : 0.3)
                                            ])
                                      }, React.createElement(TraitImage.make, {
                                            traitId: traitId,
                                            rank: rank,
                                            size: 64
                                          }));
                          })))));
}

var make = WrappedChaseTraits;

export {
  make ,
  
}
/* CssJs Not a pure module */
